// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"19f35dfd","453":"5b5847ed","474":"7460032f","638":"200137e3","641":"f58e79f7","676":"11766784","716":"4865bfcb","756":"859e3f9c","875":"940febbb"}[chunkId] + ".chunk.js";
};